import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useRouter } from "next/router";

// Local components
import FormProvider from "../hook-form/FormProvider";
import Iconify from "../iconify";
import IconCode from "@/src/lib/iconCode";
import { testApiService } from "@/src/lib/api-services/testApiServices";
import Progressbar from "../loading";
import { useCustomQuery } from "@/src/lib/hooks/useFetch";
import CustomButton from "@/src/lib/ui/Button";
import CustomIconButton from "@/src/lib/ui/iconButton";
import useBreakpoint from "@/src/lib/util/custom-hooks/useBreakPoint";
import ConfirmDialog from "@/src/lib/ui/confirmDialog";
import CustomCheckbox from "@/src/lib/ui/customCheckbox";

const SelectPatientForm = ({ open, onSubmit, onClose, isDisabled }) => {
    const methods = useForm();
    const router = useRouter();
    const [selectedPatients, setSelectedPatients] = useState([]);

    const { data: patientList, isLoading } = useCustomQuery(
        "patient_list",
        testApiService.getPatientList,
        {
            enabled: !!open,
        }
    );

    const patients = patientList?.data?.data || [];

    const handleCheckboxChange = (e, patientGuid) => {
        if (e.target.checked) {
            setSelectedPatients([...selectedPatients, patientGuid]);
        } else {
            setSelectedPatients(
                selectedPatients.filter((id) => id !== patientGuid)
            );
        }
    };

    const handleDoneClick = () => {
        !isDisabled && onSubmit(selectedPatients);
    };

    const handleManagePatient = () => {
        router.push("/my-account/members");
    };

    const onCloseHandle = () => {
        setSelectedPatients([]);
        onClose();
    };
    const isMobile = useBreakpoint("sm");

    return (
        <ConfirmDialog
            open={open}
            onClose={onCloseHandle}
            maxWidth="md"
            fullScreen={isMobile}
            title={
                <div className="flex justify-between items-center bg-white text-black border-b border-solid border-gray-200 -mx-4 px-4 pb-4">
                    <h6 className="text-lg font-bold"> Select Members </h6>

                    <CustomIconButton
                        onClick={() => {
                            onCloseHandle();
                        }}
                        aria-label="close"
                    >
                        <Iconify
                            icon={IconCode.close}
                            width="16px"
                            className="text-primary"
                        />
                    </CustomIconButton>
                </div>
            }
            content={
                <>
                    <div className="p-0">
                        <FormProvider
                            methods={methods}
                            onSubmit={methods.handleSubmit((data) =>
                                console.log(data)
                            )}
                        >
                            <div>
                                <div className="flex flex-col md:gap-3 gap-1 max-h-[350px] overflow-y-auto">
                                    {isLoading ? (
                                        <div className="flex justify-center items-center py-8">
                                            <Progressbar size={40} color="primary" />
                                        </div>
                                    ) : patients?.length > 0 ? (
                                        patients.map((patient, index) => {
                                            const checked =
                                                Array.isArray(selectedPatients) &&
                                                selectedPatients
                                                    ? selectedPatients.includes(
                                                          patient.patientId
                                                      )
                                                    : false;

                                            return (
                                                <div
                                                    key={index}
                                                    className={`p-3 ${
                                                        checked
                                                            ? "bg-primary/10"
                                                            : "bg-gray-100"
                                                    }`}
                                                >
                                                    <CustomCheckbox
                                                        checked={checked}
                                                        onChange={(e) =>
                                                            handleCheckboxChange(
                                                                e,
                                                                patient.patientId
                                                            )
                                                        }
                                                        label={patient.pName}
                                                    ></CustomCheckbox>
                                                </div>
                                            );
                                        })
                                    ) : (
                                        <div className="flex justify-center items-center py-8 text-gray-500">
                                            <p>No patients found. Please add family members first.</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </FormProvider>
                    </div>

                    <div className="flex flex-col gap-2 md:mt-4 mt-2">
                        <CustomButton
                            className={`w-full mb-1 font-bold mb-2 w-full text-base ${
                                selectedPatients.length > 0
                                    ? "bg-primary text-white"
                                    : "bg-gray-300 text-gray-500"
                            }`}
                            variant="contained"
                            onClick={handleDoneClick}
                            disabled={
                                isDisabled || selectedPatients.length === 0
                            }
                        >
                            {isDisabled ? (
                                <Progressbar size={24} color="inherit" />
                            ) : (
                                "Done"
                            )}
                        </CustomButton>

                        <CustomButton
                            className="text-primary border-primary border border-solid w-full font-bold"
                            variant="outlined"
                            onClick={handleManagePatient}
                        >
                            Manage Family Members
                        </CustomButton>
                    </div>
                </>
            }
        ></ConfirmDialog>
    );
};

export default SelectPatientForm;
